import * as z from "zod";
import { NotionProductKnowledgeEditSummary } from "./list-product-knowledge-edits";

const NotionProductKnowledgeEditFull = NotionProductKnowledgeEditSummary.extend(
  { unifiedDiff: z.string().nullable() },
);

export const getProductKnowledgeEdit = {
  name: "getProductKnowledgeEdit" as const,
  input: z.object({ id: z.string() }),
  output: NotionProductKnowledgeEditFull.nullable(),
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { NotionProductKnowledgeEditEventType } from "./list-product-knowledge-edits";
